import { TokenizationRequest } from '@/api';

export const getUrl = (request: TokenizationRequest) => {
  return `${request.gateway}?msgTime=${request.msgTime}&msgId=${request.msgId}&orderId=${request.orderId}&providerId=${
    request.providerId
  }&text=${request.text}&language=${request.language}&callback=${encodeURIComponent(request.callback)}&sign=${
    request.sign
  }`;
};
